<script lang="ts">
  import type { UserCheckpointStore } from 'shared/src/user/userLessons/user.checkpoint.store';
  import { autorun } from 'mobx';
  import type { TestAttemptStore } from 'shared/src/user/tests/checkpoint.attempt.store';
  import LessonOrCheckpointDueDate from './LessonOrCheckpointDueDate.svelte';
  import { dateString, dateTimeString } from 'shared/src/utils/date.utils';
  import { onDestroy } from 'svelte';
  import CheckpointInlineStatusAttemptLi from './CheckpointInlineStatusAttemptLI.svelte';

  export let checkpointStore: UserCheckpointStore;

  let props: {
    isPassingRequired: boolean;
    requiredPassingPercent: number | false;
    hasAttemptsRemaining: boolean;
    score: number;
    attempts: TestAttemptStore[];
    remainingAttempts: number;
    numberOfAttempts: number;
    isLate: boolean | undefined;
    gradePenalty: number | undefined;
    isComplete: boolean;
    attemptToUse: TestAttemptStore | undefined;
    isPassed: boolean;
    isDueDateVisible: boolean;
    isDue: boolean;
    futureGradePenalty: number;
  };
  const destroyer = autorun(() => {
    const numberOfAttempts = checkpointStore.attempts.length;
    const isLate = checkpointStore.attemptToUse?.isLate;
    const gradePenalty = checkpointStore.attemptToUse?.gradePenalty;
    const {
      isComplete,
      attemptToUse,
      isPassingRequired,
      requiredPassingPercent,
      hasAttemptsRemaining,
      score,
      attempts,
      remainingAttempts,
      isPassed,
      isDueDateVisible,
      isDue,
      futureGradePenalty,
    } = checkpointStore;
    props = {
      numberOfAttempts,
      isLate,
      gradePenalty,
      isComplete,
      attemptToUse,
      isPassingRequired,
      requiredPassingPercent,
      hasAttemptsRemaining,
      score,
      attempts,
      remainingAttempts,
      isPassed,
      isDueDateVisible,
      isDue,
      futureGradePenalty,
    };
  });

  onDestroy(destroyer);
</script>

<div class="text-sm">
  <LessonOrCheckpointDueDate lessonOrCheckpointStore={checkpointStore} />
  {#if props.attemptToUse}
    <div>
      {#if props.isPassingRequired && props.numberOfAttempts}
        {props.isPassed
          ? 'Complete!'
          : 'Not passed: ' + props.requiredPassingPercent + '% required'}<br />
      {/if}
      {#if props.isPassingRequired && !props.numberOfAttempts}
        {checkpointStore.requiredPassingPercent}% required to pass
      {/if}

      <a href="/app/checkpoints/{checkpointStore.id}/attempts/{props.attemptToUse.id}" class="a">
        {props.hasAttemptsRemaining ? 'Top ' : ''}Score: {Math.round(props.score)}% –
        {dateString(new Date(props.attemptToUse.record.updatedAt))} at {dateTimeString(
          new Date(props.attemptToUse.record.updatedAt)
        )}
      </a>
    </div>
  {/if}

  <ul>
    <li>
      {#each props.attempts as attempt, index}
        <CheckpointInlineStatusAttemptLi {attempt} {index} />
      {/each}
    </li>
  </ul>
  <div>
    {props.remainingAttempts === Infinity ? 'Unlimited' : props.remainingAttempts}
    {props.remainingAttempts == 1 ? 'attempt' : 'attempts'} remaining
    {#if props.isDueDateVisible && props.isDue && props.futureGradePenalty}
      <br />Further attempts will have a {props.futureGradePenalty}% late deduction.
    {/if}
  </div>
</div>
